import { createAsyncThunk } from '@reduxjs/toolkit';
import { WEB_API_ROUTES } from 'api/api-routes';
import api from 'api';
import { createThunk } from '../../utils/storeUtils';
import { handleServerErrors } from '../../utils/server-errors';
import { thunks as generalThunks } from '../general/thunks';

const refreshStudioLocations = async (dispatch, getState) => {
  const studioId = getState().general?.profile?.studio?.id;

  if (!studioId) return;

  await dispatch(generalThunks.getStudio({ studioId }));
};

const createConfigurationMutationThunk = (type, apiCall) =>
  createAsyncThunk(type, async (payload, { dispatch, getState }) => {
    try {
      const response = await apiCall(payload);
      await refreshStudioLocations(dispatch, getState);

      return response.data;
    } catch (err) {
      handleServerErrors(err);
      throw err;
    }
  });

export const thunks = {
  getConfigurationSettings: createThunk(
    'configuration/getConfigurationSettings',
    () => api.get(WEB_API_ROUTES.settings.config)
  ),

  updateConfigurationSettings: createConfigurationMutationThunk(
    'configuration/updateConfigurationSettings',
    (data) => api.put(WEB_API_ROUTES.settings.config, data)
  ),

  deleteLocation: createConfigurationMutationThunk(
    'configuration/deleteLocation',
    (locationId) =>
      api.delete(
        WEB_API_ROUTES.settings.deleteLocation.replace(
          '{locationId}',
          locationId
        )
      )
  ),

  deleteRoom: createConfigurationMutationThunk(
    'configuration/deleteRoom',
    (roomId) =>
      api.delete(WEB_API_ROUTES.settings.deleteRoom.replace('{roomId}', roomId))
  ),
};
